/* eslint-disable max-lines */
import '../c/appid_LTE.pcss';
import $ from 'jquery';
import angular from 'angular';
import 'angular-messages';
import './lib/design-radio-checkbox';
import './lib/design-select';
var CONSTANTS = {
	APPID: 'prepaidltesimcsere',
	API_URL: '/lakossagi/api/lte-sim',
	SUCCESS_CODE: 'success',
	INVALID_FORM_CODE: 'invalid',
	GENERAL_ERROR_CODE: 'generalError',
	IN_PROGRESS_TEXT: 'Folyamatban...'
};

var onRecaptchaSuccess

/**
 * Kihordó objektum
 * Ezen beállítások és transzformációk szükséges a kihordón át szállított POST requestekhez
 */

var Kihordo = (function () {
	var parser = new DOMParser();
	return {
		transformResponse: function (data) {
			try {
				var doc = parser.parseFromString(data, 'text/html');
				var json = doc.querySelector('p')?.textContent;
				if (!json) throw new Error('Empty response');
				return JSON.parse(json);
			} catch (e) {
				return { success: false };
			}
		},
		transformRequest: function (appid, request) {
			var obj = {
				appid: appid,
				op: request.op,
				data: JSON.stringify(request.data)
			};

			return $.param(obj);
		},
		getContentType: function () {
			return 'application/x-www-form-urlencoded;charset=utf-8';
		}
	};
})();
angular
	.module('lte', ['ngMessages'])
	.constant('Constants', CONSTANTS)
	.config([
		'$httpProvider',
		'Constants',
		function ($httpProvider, Constants) {
			$httpProvider.defaults.headers.post['Content-Type'] = Kihordo.getContentType();
			$httpProvider.defaults.transformResponse = function (requestData) {
				return Kihordo.transformResponse(requestData);
			};
			$httpProvider.defaults.transformRequest = function (request) {
				return Kihordo.transformRequest(Constants.APPID, request);
			};
		}
	])
	.controller('LteController', [
		'$scope',
		'utils',
		'ajax',
		'errorHandler',
		'$timeout',
		'Constants',
		function ($scope, utils, ajax, errorHandler, $timeout, Constants) {
			var recaptchaWidgetId;
			$scope.recaptchaAction = '';

			$scope.model = {
				address: {
					onlyParcelNumber: false
				}
			};

			$scope.mobile = {
				prefix: '+36',
				area: '30',
				number: ''
			};

			$scope.request = {
				otp: false,
				save: false
			};

			$scope.save = {};

			window.onRecaptchaLoad = function() {
				recaptchaWidgetId = grecaptcha.render('recaptcha-container', {
					'callback': onRecaptchaSuccess,
					'size': 'invisible'
				});
			};

			onRecaptchaSuccess = function(token) {
				$scope.$apply(function() {
					if ($scope.recaptchaAction === 'getOTP') {
						var mobileNumber = utils.mobileObjectToString($scope.mobile);
						ajax.getOTP(mobileNumber, token, $scope.otpSuccessCallback, $scope.otpErrorCallback);
					} else if ($scope.recaptchaAction === 'save') {
						$scope.model.mobileNumber = utils.mobileObjectToString($scope.mobile);
						ajax.save($scope.model, token, $scope.successCallback, errorCallback);
					}
				});
			};

			function animateTo(elem) {
				$('html, body').animate(
					{
						scrollTop: Math.ceil(elem.offset().top - $(window).height() / 2)
					},
					1000
				);
			}
			function animateToFirstError() {
				var $firstError = $('p.error-message:visible').first();
				var elementToScrollPosition = $firstError.offset().top;
				var currentPosition = $(document).scrollTop();
				if (elementToScrollPosition < currentPosition) {
					animateTo($('p.error-message:visible').first());
				}
			}
			function animateScrollToMessages() {
				var $firstError = $('.lte-msgbox:visible').first();
				var elementToScrollPosition = $firstError.offset().top;
				var currentPosition = $(document).scrollTop();
				if (elementToScrollPosition < currentPosition) {
					animateTo($('.lte-msgbox:visible').first());
				}
			}

			$scope.requestOtpWithRecaptcha = function() {
				$scope.request.otp = true;
				$scope.recaptchaAction = 'getOTP';
				grecaptcha.execute(recaptchaWidgetId);
			};

			$scope.submit = function () {
				if ($scope.lteForm.$valid) {
					$scope.request.save = true;
					$scope.recaptchaAction = 'save';
					grecaptcha.execute(recaptchaWidgetId);
				} else {
					animateToFirstError();
				}
			};

			$scope.otpSuccessCallback = function(response) {
				var errorCode = response.data.success ? Constants.SUCCESS_CODE : response.data.errorType.toLowerCase();
				$scope.otp = errorHandler.setError($scope.otp, errorCode);
				$scope.requestNewPassword = response.data.success;
				$scope.request.otp = false;
				grecaptcha.reset(recaptchaWidgetId);
			};

			$scope.otpErrorCallback = function() {
				$scope.otp = errorHandler.setError($scope.otp, Constants.GENERAL_ERROR_CODE);
				$scope.request.otp = false;
				grecaptcha.reset(recaptchaWidgetId);
			};

			function errorCallback() {
				$scope.save = errorHandler.setError($scope.save, CONSTANTS.INVALID_FORM_CODE);
				$scope.request.save = false;
				$timeout(function () {
					animateScrollToMessages();
				});
				grecaptcha.reset(recaptchaWidgetId);
			}

			$scope.successCallback = function (response) {
				if (response.data.success) {
					$scope.save = errorHandler.setError($scope.save, Constants.SUCCESS_CODE);
					$timeout(function () {
						animateScrollToMessages();
					});
				} else {
					var errorCode = errorHandler.isCorrectableError(response.data.errorType) ? response.data.errorType.toLowerCase() : CONSTANTS.INVALID_FORM_CODE;
					$scope.save = errorHandler.setError($scope.save, errorCode);
					grecaptcha.reset(recaptchaWidgetId);
					$timeout(function () {
						animateToFirstError();
					});
				}
				$scope.request.save = false;
			};
		}
	])
	.directive('commonMessageWith', function () {
		return {
			require: 'ngModel',
			scope: {
				otherModel: '=commonMessageWith'
			},
			link: function ($scope, $element, attrs, ctrl) {
				$scope.$watch('otherModel.$modelValue', function () {
					ctrl.$validate();
				});
				ctrl.$validators.commonMessage = function () {
					var commonMessageRequired = ctrl.$error.required && $scope.otherModel.$error.required;
					return !commonMessageRequired;
				};
			}
		};
	})
	.directive('requestButton', [
		'Constants',
		function (Constants) {
			return {
				link: function ($scope, $element, attrs) {
					$scope.$watch(attrs.requestButton, function (requestInProgress) {
						if (requestInProgress) {
							$element.prop('disabled', true).text(Constants.IN_PROGRESS_TEXT);
						} else {
							$element.prop('disabled', false).text(attrs.defaultText);
						}
					});
				}
			};
		}
	])
	.directive('smsPassword', [
		'utils',
		'errorHandler',
		'Constants',
		function (utils, errorHandler, Constants) {
			return {
				require: '^form',
				link: function ($scope, $element, attrs, formCtrl) {
					var mobileNumberModelCtrl = formCtrl.mobileNumber;
					$scope.otp = {};
					$scope.forceErrorDisplay = false;

					$element.click(function (e) {
						e.preventDefault();
						$scope.requestNewPassword = false;
						mobileNumberModelCtrl.$commitViewValue();
						if (mobileNumberModelCtrl.$invalid) {
							$scope.forceErrorDisplay = true;
						} else {
							$scope.requestOtpWithRecaptcha();
						}
						$scope.$apply();
					});
				}
			};
		}
	])
	.directive('email', function () {
		return {
			require: 'ngModel',
			scope: {
				email: '='
			},
			link: function (scope, element, attrs, ngModelCtrl) {
				scope.$watch('email', function () {
					ngModelCtrl.$validate();
				});
				ngModelCtrl.$validators.email = function (modelValue, viewValue) {
					var value = '' + (modelValue || viewValue || '');
					var pattern =
						// eslint-disable-next-line no-control-regex
						/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;
					return value.match(pattern) != null;
				};
			}
		};
	})
	.directive('numbersOnly', function () {
		var DEFAULT_MAX_LENGTH = 16;
		return {
			link: function ($scope, $element, attrs) {
				var maxlength = parseInt(attrs.ngMaxlength, 10) || DEFAULT_MAX_LENGTH;
				$element.keydown(function (e) {
					if ($.inArray(e.keyCode, [46, 8, 9, 27, 13]) !== -1 || (e.keyCode == 65 && e.ctrlKey === true) || (e.keyCode >= 35 && e.keyCode <= 39)) {
						return;
					}
					if (((e.shiftKey || e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105) && e.keyCode !== 192) || $element.val().length >= maxlength) {
						e.preventDefault();
					}
					// WinPhone hack
					if ($element.val().length >= maxlength) {
						$element.val($element.val().substr(0, maxlength));
					}
				});
			}
		};
	})
	.factory('ajax', [
		'$http',
		'Constants',
		function ($http, Constants) {
			var requestTypes = {
				GET_OTP: 'getOneTimePassword',
				SAVE: 'save'
			};

			return {
				getOTP: function (mobileNumber, token, callback, errorCallback) {
					var urlWithToken = Constants.API_URL + '?g-recaptcha-response=' + encodeURIComponent(token || '');
					var request = {
						op: requestTypes.GET_OTP,
						data: {
							mobileNumber: mobileNumber
						}
					};
					$http.post(urlWithToken, request).then(callback).catch(errorCallback);
				},

				save: function (data, token, callback, errorCallback) {
					var urlWithToken = Constants.API_URL + '?g-recaptcha-response=' + encodeURIComponent(token || '');
					var request = {
						op: requestTypes.SAVE,
						data: data
					};
					$http.post(urlWithToken, request).then(callback).catch(errorCallback);
				},
			};
		}
	])
	.factory('errorHandler', function () {
		return {
			setError: function (object, errorCode) {
				object = {};
				object[errorCode] = true;
				return object;
			},

			isCorrectableError: function (errorCode) {
				var correctableErrorCodes = ['INVALID_OTP_CODE', 'EXPIRED_OTP_CODE'];
				return correctableErrorCodes.indexOf(errorCode) > -1;
			}
		};
	})
	.factory('utils', function () {
		return {
			mobileObjectToString: function (phoneObject) {
				return phoneObject.prefix + phoneObject.area + phoneObject.number;
			}
		};
	});
